import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {Page} from '@/hooks/empresa/organizacion/use-businesses'
import {track} from '@/lib/telemetry'
import type {components} from '@/lib/api-schema'

export type ItemNote = components['schemas']['ItemNoteRead']

export const NOTAS_PAGE_SIZE = 20

export function useItemNotes(businessId: string | undefined, code: string | undefined, enabled: boolean, page = 1) {
  return useQuery({
    queryKey: ['item-notes', businessId, code, page],
    queryFn: async () =>
      (
        await api.get<Page<ItemNote>>(`/businesses/${businessId}/sgsst/items/${code}/notas`, {
          params: {page, page_size: NOTAS_PAGE_SIZE},
        })
      ).data,
    enabled: enabled && !!businessId && !!code,
    placeholderData: (previous) => previous,
  })
}

export function useAddItemNote(businessId: string, code: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (text: string) =>
      (await api.post<ItemNote>(`/businesses/${businessId}/sgsst/items/${code}/notas`, {text})).data,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['item-notes', businessId, code]})
      track('item_note_added', {business_id: businessId, standard_code: code})
    },
  })
}

export function useDeleteItemNote(businessId: string, code: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (noteId: string) => api.delete(`/businesses/${businessId}/sgsst/items/${code}/notas/${noteId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['item-notes', businessId, code]})
      track('item_note_removed', {business_id: businessId, standard_code: code})
    },
  })
}
